// import clsx from 'clsx';
// import { useImmer } from 'use-immer';
import ThemeSetting from './Theme.Setting';

// enum SettingTab {
//   theme,
//   user,
// }

const Setting = (): JSX.Element => {
  // const [tabSetting, setTabSetting] = useImmer<SettingTab>(SettingTab.theme);
  return (
    <div className="flex flex-col">
      <div className="p-3 space-y-4">
        {/* <div className="flex space-x-8 text-md text-gray-600 font-medium">
          <button
            type="button"
            onClick={() => {
              setTabSetting(SettingTab.theme);
            }}
            className={clsx(
              tabSetting === SettingTab.theme
                ? 'border-indigo-600 text-indigo-600'
                : null,
              'p-2 border-b-2 border-transparent',
            )}
          >
            Cấu hình chung
          </button>
          <button
            type="button"
            onClick={() => {
              setTabSetting(SettingTab.user);
            }}
            className={clsx(
              tabSetting === SettingTab.user
                ? 'border-indigo-600 text-indigo-600'
                : null,
              'p-2 border-b-2 border-transparent',
            )}
          >
            Thông tin quản trị viên
          </button>
        </div> */}
        <div className="shadow-sm bg-white rounded-lg overflow-x-auto">
          <ThemeSetting />
        </div>
      </div>
    </div>
  );
};

export default Setting;
